import { useState } from 'react';
import { MDText } from 'i18n-react';

import { DamageMissingTrimIcon } from '@motorway/mw-highway-code';
import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { LOCAL_STORAGE_KEYS } from 'Utilities/helpers/localStorage.const';
import { setValueInLocalStorage } from 'Utilities/helpers/localStorage.helpers';

import texts from './NewGradingInfoBox.texts';

import styles from './NewGradingInfoBox.module.scss';

const LocalT = new MDText(texts);

// Temporary and to be removed when we make a decision on saved searches using legacy grading
export const NewGradingInfoBox = () => {
	const [hasGradingExplanationBeenDismissed, setHasGradingExplanationBeenDismissed] = useState(false);

	if (hasGradingExplanationBeenDismissed) {
		return null;
	}

	const onClose = () => {
		setValueInLocalStorage({
			id: LOCAL_STORAGE_KEYS.GRADING_SAVED_SEARCHES_EXPLANATION_DISMISSED,
			value: 'true',
		});
		setHasGradingExplanationBeenDismissed(true);
	};

	return (
		<div className={styles.container}>
			<InfoBox
				content={LocalT.translate(texts.description)}
				heading={LocalT.translate(texts.title)}
				icon={DamageMissingTrimIcon}
				onClose={onClose}
				variant="info"
			/>
		</div>
	);
};
